import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { RetryQueryAlert } from 'src/components/alerts/RetryQueryAlert';
import { Card } from 'src/components/ui/card';
import { useForecastSession } from 'src/features/forecastSessions/useForecastSession';
import { getForecastSessionsQueryKey } from 'src/keys';

type ForecastSessionGateProps = {
  children: ReactElement[] | ReactElement;
};

export function ForecastSessionGate({
  children,
}: ForecastSessionGateProps): ReactElement {
  const { t } = useTranslation('forecast');
  const { isLoading, isReady, error, sessions } = useForecastSession();

  if (error) {
    return (
      <div className='flex h-full w-full items-center justify-center p-6'>
        <div className='w-full max-w-lg'>
          <RetryQueryAlert
            isLoading={isLoading}
            queryKey={getForecastSessionsQueryKey()}
          />
        </div>
      </div>
    );
  }

  if (isLoading || !isReady) {
    return (
      <div className='flex h-full w-full items-center justify-center p-6'>
        <div className='h-10 w-10 animate-spin rounded-full border-4 border-border-default border-t-primary-default' />
      </div>
    );
  }

  if (sessions.length === 0) {
    return (
      <div className='flex h-full w-full items-center justify-center p-6'>
        <Card className='w-full max-w-lg p-6 text-center text-layout-foreground-secondary text-sm'>
          {t('No open sessions available')}
        </Card>
      </div>
    );
  }

  return <>{children}</>;
}
